<template>
    <el-card class="page_card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>文章管理</span>
        </div>
        <el-form inline ref="selectForm" :model="selectForm">
            <el-form-item label="标题">
                <el-input placeholder="标题模糊搜索" clearable v-model="selectForm.name"></el-input>
            </el-form-item>
<!--            <el-form-item label="分类">-->
<!--                <el-select v-model="selectForm.catId" placeholder="请选择">-->
<!--                    <el-option-->
<!--                        v-for="item in cat_list"-->
<!--                        :key="item.id"-->
<!--                        :label="item.name"-->
<!--                        :value="item.id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="">
                <el-button plain type="primary" @click="select" :loading="is_post">查 询</el-button>
                <el-button plain type="success" @click="goToAdd">+ 添加文章</el-button>
<!--                <el-button plain type="warning" @click="cat_option_dialog = !cat_option_dialog">栏目设置</el-button>-->
            </el-form-item>
        </el-form>

        <el-alert
            title="排序为正序排列(序号小的在前面)"
            type="warning"
            style="margin-bottom: 20px"
        >
        </el-alert>

        <el-table :data="data" stripe v-loading="is_loading">
            <el-table-column label="标题" width="250">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false" @click="preview(scope.row)">{{scope.row.name}}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="摘要">
                <template slot-scope="scope">
                    {{scope.row.desc}}
                </template>
            </el-table-column>
            <el-table-column label="排序" prop="sort_num" sortable width="150">
                <template slot-scope="scope">
                    <span v-if="!scope.row.is_edit">
                        {{scope.row.sort_num}}
                    </span>
                    <el-input-number v-else v-model="scope.row.sort_num" controls-position="right" :min="0" :max="1000" size="mini" style="width: 100px;display:inline-block;"></el-input-number>
                    <el-link type="warning" :underline="false" @click="editSort(scope.row,scope.$index)" v-if="!scope.row.is_edit">修改</el-link>
                    <el-link type="success" :underline="false" @click="saveSort(scope.row,scope.$index)" v-else>保存</el-link>
                </template>
            </el-table-column>
            <el-table-column label="添加时间" prop="created_at" sortable>
                <template slot-scope="scope">
                    {{scope.row.created_at}}
                </template>
            </el-table-column>
            <el-table-column label="变更时间" prop="updated_at" sortable>
                <template slot-scope="scope">
                    {{scope.row.updated_at}}
                </template>
            </el-table-column>
            <el-table-column label="状态" width="65">
                <template slot-scope="scope">
                    <el-link :underline="false" type="success" v-if="scope.row.is_show == 1" @click="setShow(scope.row,0)">正常</el-link>
                    <el-link :underline="false" type="warning" v-if="scope.row.is_show == 0" @click="setShow(scope.row,1)">禁用</el-link>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
<!--                    <el-button type="primary" plain size="mini">查看</el-button>-->
                    <el-button type="warning" plain size="mini" @click="goToEdit(scope.row)">修改</el-button>
                    <el-button type="danger" plain size="mini" :loading="is_post" @click="del(scope.row,scope.$index)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>



        <el-dialog title="栏目设置" :visible.sync="cat_option_dialog" width="40%">
            <el-row>
                <el-col :span="24">
                    <el-button size="mini"  type="success" plain @click="add_cat">+ 添加栏目</el-button>
                    <el-table :data="cat_list" stripe max-height="400">
                        <el-table-column label="栏目名称">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="primary">{{scope.row.name}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="文章数量">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="primary">{{scope.row.num}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="排序">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="warning">{{scope.row.sortNum}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="success" v-if="scope.row.isShow == 1">正常</el-link>
                                <el-link :underline="false" type="warning" v-if="scope.row.isShow == 0">禁用</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" plain type="warning" @click="cat_edit_btn(scope.row,scope.$index)"><i class="el-icon-edit" /></el-button>
                                <el-button size="mini" plain type="danger" @click="cat_del_btn(scope.row,scope.$index)"><i class="el-icon-delete" /></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog :visible.sync="add_cat_dialog" title="添加栏目" width="25%">
            <el-form label-width="120px" ref="addForm" :model="addForm" :rules="rules">
                <el-form-item label="栏目名称" prop="name">
                    <el-input v-model="addForm.name" placeholder="请输入栏目名称" maxlength="6" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sortNum">
                    <el-input v-model="addForm.sortNum" placeholder="排序序号"></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch
                        v-model="addForm.isShow"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain @click="addSubmit" :loading="is_post">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="edit_cat_dialog" title="修改栏目" width="25%">
            <el-form label-width="120px" ref="editForm" :model="editForm" :rules="rules">
                <el-form-item label="栏目名称" prop="name">
                    <el-input v-model="editForm.name" placeholder="请输入栏目名称" maxlength="6" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sortNum">
                    <el-input v-model="editForm.sortNum" placeholder="排序序号"></el-input>
                </el-form-item>
                <el-form-item label="是否启用">
                    <el-switch
                        v-model="editForm.isShow"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="warning" plain @click="editSubmit" :loading="is_post">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="文章预览" width="454px" top="20px" :visible.sync="preview_dialog">
            <iframe :srcdoc="preview_html" loading="lazy" frameborder="0" scrolling="auto" height="736" width="414" style="overflow-y: auto"></iframe>
        </el-dialog>

    </el-card>
</template>

<script>
import request from '@/utils/request'
import NodeRequest from "@/utils/node-request"

export default {
    name: 'article_index',
    data(){
        return {
            is_ok:false,
            is_post:false,
            is_loading:false,
            cat_option_dialog:false,
            add_cat_dialog:false,
            edit_cat_dialog:false,
            preview_dialog:false,
            editForm:{
                id:0,
                isShow:true,
                name:"",
                sortNum:""
            },
            cat_list:[
                {id:"all",name:"全部",num:10,isShow:1,sortNum:0},
                {id:1,name:"气质报告",num:5,isShow:1,sortNum:1},
                {id:2,name:"今日资讯",num:3,isShow:1,sortNum:2},
                {id:3,name:"液厂公告",num:2,isShow:1,sortNum:3},
            ],
            data:[],
            selectForm:{
                name:"",
                // catId:"",
            },
            addForm:{
                isShow:true,
                name:"",
                sortNum:""
            },
            rules:{
                name:[
                    { required: true, message: '请输入栏目名称', trigger: 'blur' }
                ],
                sortNum:[
                    { required: true, message: '请输入排序序号', trigger: 'blur' },
                    { type: 'number', message: '序号必须为数字'}
                ]
            },
            preview_url:"",
            preview_html:""
        }
    },
    methods:{
        select(){
            this.getData();
        },
        cat_edit_btn(item,index){
            this.editForm.id = item.id;
            this.editForm.name = item.name;
            this.editForm.sortNum = item.sortNum;
            this.editForm.isShow = item.isShow == 1?true:false;
            this.edit_cat_dialog = true;
        },
        cat_del_btn(item,index){
            this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            });
        },
        goToAdd(){
            this.$router.push({name:"article_add"});
        },
        getData(is_init = false){
            if(!is_init){
                this.is_post = true;
                this.is_loading = true;
            }
            NodeRequest.post("article/index",this.selectForm).then(res=>{
                res.data.map((item)=>{
                    item.is_edit = false;
                });
                this.data = res.data;
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            }).catch(err=>{
                if(!is_init){
                    this.is_post = false;
                    this.is_loading = false;
                }else{
                    this.is_ok = true;
                }
            });
        },
        editSort(item,i){
            item.is_edit = !item.is_edit;
        },
        saveSort(item,i){
            if(!item.sort_num){
                item.sort_num = 0;
            }else if(isNaN(item.sort_num)){
                this.$message.warning("参数错误!");
                return false;
            }
            this.is_post = true;
            NodeRequest.post("article/set_sort",{id:item.id,sort_num:item.sort_num}).then(res=>{
                item.is_edit = !item.is_edit;
                this.is_post = false;
                this.$message.success("修改成功!");
            }).catch(err=>{
                this.is_post = false;
            });
        },
        add_cat(){
            this.add_cat_dialog = true;
        },
        //添加提交
        addSubmit(){

        },
        //修改提交
        editSubmit(){

        },
        goToEdit(item){
            this.$router.push({name:'article_edit',params:{id:item.id}});
        },
        setShow(item,is_show){
            this.is_post = true;
            NodeRequest.post("article/set_show",{id:item.id,is_show}).then(res=>{
                this.$message.success("修改状态成功!");
                item.is_show = is_show;
                this.is_post = false;
            }).catch(err=>{
                this.is_post = false;
            });
        },
        del(item){
            this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.is_post = true;
                NodeRequest.post("article/del",{id:item.id}).then(res=>{
                    this.$message.success("删除文章成功!");
                    for(let i =0;i<this.data.length;i++){
                        if(this.data[i].id == item.id){
                            this.data.splice(i,1)
                        }
                    }
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        preview(item){
            this.preview_html = item.content;
            // this.preview_url = process.env.VUE_APP_ARTICLE_PREVIEW+"/review/article/"+item.id;
            this.preview_dialog = true;
        }
    },
    created() {

    },
    mounted() {
        this.getData(true);
    }
}
</script>

<style scoped lang="scss">

</style>
